import { checkPermissions } from "@elit-hair/elit-tools";
import { useTranslation } from "react-i18next";
import { TbCalendarMonth, TbCast, TbDashboard, TbMapPin } from "react-icons/tb";
import { Link } from "react-router-dom";

import { PERMISSIONS } from "@/constants/permissions";
import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";
import useAuth from "@/providers/hooks/useAuth";

import LandingShiftComp from "./components/LandingShift/LandingShiftComp";

const LandingPage = () => {
    const { t } = useTranslation();

    return (
        <Panel title={<PanelTitle title={t("welcome")} />}>
            <div className="container mx-auto grid grid-cols-3 max-xl:grid-cols-1 max-md:flex max-md:flex-col-reverse md:mt-10 w-full gap-4 justify-self-stretch">
                <HeroSection />
                <LandingShiftComp />
            </div>
        </Panel>
    );
};

function HeroSection() {
    const { t } = useTranslation();
    const { userData } = useAuth();
    if (!checkPermissions(userData?.permissionCodes, [PERMISSIONS.TR_SVC_PASSENGERS_LIST_BY_DATE])) return null;
    return (
        <div className="bg-white md:bg-elitDarkBlue p-6 lg:p-14 relative col-span-3 max-xl:col-span-1 rounded-3xl h-fit">
            <div className="absolute bottom-0 right-0 h-full bg-elitBlue w-[500px] lg:w-[600px] max-md:hidden select-none rounded-3xl">
                <img
                    src="/mercedes.png"
                    className="absolute w-full -bottom-10 -right-2 drop-shadow-2xl z-10 scale-125"
                    draggable={false}
                />
                <img
                    src="/sliderEffect.png"
                    className="absolute w-fit h-full bottom-0 -left-4 antialiased"
                    draggable={false}
                />
            </div>
            <div className="flex flex-col gap-4 w-full max-md:w-full lg:ml-24">
                <div className="flex flex-col gap-3">
                    <h3 className="text-3xl font-semibold z-20 md:text-white">
                        {t("welcome")} {userData?.name}
                    </h3>
                    <p className="md:text-white/60">{t("elit-transport-management")}</p>
                </div>
                <span className="py-3 text-elitLightBlue bg-elitLightBlue/15 w-full md:w-fit rounded-full border border-elitLightBlue text-sm font-semibold px-6 flex items-center gap-3 hover:bg-elitLightBlue/30 transition-colors duration-300">
                    <Link to="/new-tracking" className="flex items-center gap-2">
                        <TbDashboard className="w-5 h-5" /> {t("real_time_tracking")}
                    </Link>
                </span>
                <span className="py-3 text-elitLightBlue bg-elitLightBlue/15 w-full md:w-fit rounded-full border border-elitLightBlue text-sm font-semibold px-6 flex items-center gap-3 hover:bg-elitLightBlue/30 transition-colors duration-300">
                    <Link to="/plan" className="flex items-center gap-2">
                        <TbCalendarMonth className="w-5 h-5" /> {t("daily_plan")}
                    </Link>
                </span>
                <span className="py-3 text-elitLightBlue bg-elitLightBlue/15 w-full md:w-fit rounded-full border border-elitLightBlue text-sm font-semibold px-6 flex items-center gap-3 hover:bg-elitLightBlue/30 transition-colors duration-300">
                    <Link to="/map" className="flex items-center gap-2">
                        <TbMapPin className="w-5 h-5" /> {t("real_time_map")}
                    </Link>
                </span>
                <span className="py-3 text-elitLightBlue bg-elitLightBlue/15 w-full md:w-fit rounded-full border border-elitLightBlue text-sm font-semibold px-6 flex items-center gap-3 hover:bg-elitLightBlue/30 transition-colors duration-300">
                    <Link to="/cameras" className="flex items-center gap-2">
                        <TbCast className="w-5 h-5" /> {t("camera_control")}
                    </Link>
                </span>
            </div>
        </div>
    );
}
export default LandingPage;
